export default "__VITE_ASSET__C5guQtZ3__"